import { render, staticRenderFns } from "./BikkuraponIcon.vue?vue&type=template&id=3d5959f8&scoped=true&"
var script = {}
import style0 from "./BikkuraponIcon.vue?vue&type=style&index=0&id=3d5959f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5959f8",
  null
  
)

export default component.exports